<div [attr.data-automation]="config.dataAutomation">
  <h5>
    @if (state.required) {
      <span class="text-danger ziro-forms-asterisk">*</span>
    }
    <span [innerHTML]="getLabel() | escapeHtml"></span>
  </h5>
  <div class="align-items-center d-flex group-item-text-wrapper">
    <p class="general-settings-text__content" [innerHTML]="config.options?.content | escapeHtml"></p>
    <div class="general-settings-text__input">
      <div
        class="mb-3 row"
        [hidden]="state.hidden"
        [attr.data-automation]="config.dataAutomation + '-input'"
        [ngClass]="{
          'has-feedback': showValidation || isFormSubmitted,
          'ziro-forms-error': validationState === ValStates.INVALID,
          'ziro-forms-warning': validationState === ValStates.PENDING || validationState === ValStates.WARNING,
          'ziro-forms-success': validationState === ValStates.VALID && showAsyncValidation,
        }"
      >
        <div class="col">
          <div
            class="input-group"
            [ngClass]="{ 'input-group-lg': inputSize === inputSizes.LG, 'input-group-sm': inputSize === inputSizes.SM }"
          >
            @if (inputAddOn && inputAddOn?.prependedContent) {
              <span class="input-group-text input-text-start">
                {{ inputAddOn?.prependedContent | translate }}
              </span>
            }
            <input
              class="form-control"
              [ngClass]="{
                'ziro-text-pending': validationState === ValStates.PENDING,
                'input-text-end': inputAddOn?.prependedContent && !inputAddOn?.appendedContent,
                'input-text-start': inputAddOn?.appendedContent && !inputAddOn?.prependedContent,
                'border-radius-0': inputAddOn?.prependedContent && inputAddOn?.appendedContent,

                'border-rad-all-8': !inputAddOn?.prependedContent && !inputAddOn?.appendedContent,
              }"
              [disabled]="state.disabled"
              [type]="inputType"
              [attr.id]="config.dataAutomation + '-input'"
              #ngModelDir="ngModel"
              (ngModelChange)="updateStateAndSelf($event, ngModelDir)"
              [(ngModel)]="fieldData"
              [placeholder]="placeholder"
              data-automation="ziro-text-input"
            />
            @if (inputAddOn && inputAddOn?.appendedContent) {
              <span class="input-group-text input-text-end">
                {{ inputAddOn?.appendedContent | translate }}
              </span>
            }

            <span
              class="{{ ziroIcons.SAVING }} form-control-feedback"
              [hidden]="!(validationState === ValStates.PENDING && showAsyncValidation)"
              data-automation="ziro-text-async-pending"
            ></span>

            <span
              class="{{ ziroIcons.REMOVE }} form-control-feedback"
              [hidden]="!(validationState === ValStates.INVALID && showAsyncValidation)"
              data-automation="ziro-text-async-invalid"
            ></span>

            <span
              class="{{ ziroIcons.SAVE_SUCCESS }} form-control-feedback"
              [hidden]="!(validationState === ValStates.VALID && showAsyncValidation)"
              data-automation="ziro-text-async-valid"
            ></span>
          </div>

          <div class="ziro-forms-feedback-area">
            <div
              class="ziro-forms-validation-message"
              data-automation="ziro-forms-validation-message"
              [hidden]="!showValidation && !isFormSubmitted"
            >
              {{ validationMessage?.content | translate: validationMessage?.params }}
            </div>
            @if (isAutogenerated) {
              <div class="form-text small" data-automation="ziro-forms-autogeneration-message">
                {{ config.autogeneration?.generatedMsg | translate }}
              </div>
            }
            @if (config.helpText) {
              <span class="small form-text text-muted">
                {{ getHelpText() | translate }}
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
